"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalElementContent = void 0;
const utils_1 = require("./utils");
const tracker_1 = require("./utils/tracker");
const getGlobalElementContent = async ({ accessToken, host, locale, environment, space, trackingApplicationName }) => {
    let client;
    try {
        client = (0, utils_1.getClient)({ accessToken, host, environment });
    }
    catch (err) {
        /* eslint-disable-next-line no-console */
        console.log('getClient error', err);
    }
    let content;
    try {
        content = await (client === null || client === void 0 ? void 0 : client.getEntries({
            content_type: 'GlobalElements',
            'fields.slug': 'koodo-global-elements',
            locale,
            limit: 1000,
            include: 10
        }));
        void (0, tracker_1.trackData)(content === null || content === void 0 ? void 0 : content.items[0], trackingApplicationName, space);
    }
    catch (err) {
        /* eslint-disable-next-line no-console */
        console.log('getEntries Error', err);
    }
    return (0, utils_1.transformObjectToRemoveFields)(content === null || content === void 0 ? void 0 : content.items[0]);
};
exports.getGlobalElementContent = getGlobalElementContent;
//# sourceMappingURL=getGlobalElementsContent.js.map